export enum DataProviders {
    None = 1 << 0,
    Snapshot = 1 << 1,
    Binance = 1 << 2
}